"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var Layout_module_scss_1 = __importDefault(require("./Layout.module.scss"));
var NavigationBar = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: Layout_module_scss_1["default"].navigationBar }, children));
};
NavigationBar.displayName = "NavigationBar";
var Sidebar = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: Layout_module_scss_1["default"].sidebar },
        React.createElement("div", { className: Layout_module_scss_1["default"].sidebarInner }, children)));
};
Sidebar.displayName = "Sidebar";
var Header = function (_a) {
    var children = _a.children;
    return (React.createElement("aside", { className: Layout_module_scss_1["default"].header }, children));
};
Header.displayName = "Header";
var Footer = function (_a) {
    var children = _a.children;
    return (React.createElement("footer", { className: Layout_module_scss_1["default"].footer }, children));
};
Footer.displayName = "Footer";
/**
 * An area for toast notifications that will also trigger a screen-reader announcement.
 * Content is absolutely positioned in the top right, but it is up to you to add appropriately styled notifications.
 * By setting the children of `<Layout.Toasts>` the screen reader will immediately read its contents, without losing
 * focus. You can safely add and remove toasts without worrying about the screen reader announcement being interrupted
 * or repeated.
 */
var Toasts = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: Layout_module_scss_1["default"].toasts, "aria-live": "assertive" }, children));
};
Toasts.displayName = "Toasts";
/**
 * Announcements intended for screen readers only. Content will be invisible for sighted users.
 * By setting the children of `<Layout.Announcers>` the screen reader will immediately read its contents,
 * without losing focus. You can safely override the contents when adding a new announcement rather than
 * appending the contents.
 */
var Announcers = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: Layout_module_scss_1["default"].announcers, "aria-live": "assertive" }, children));
};
Announcers.displayName = "Announcers";
/**
 * @deprecated Layout is deprecated. Please use draft-page-layout instead.
 */
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Layout.prototype.render = function () {
        var content = React.Children.toArray(this.props.children);
        var navbar = extractChildOfType(content, NavigationBar);
        var header = extractChildOfType(content, Header);
        var sidebar = extractChildOfType(content, Sidebar);
        var footer = extractChildOfType(content, Footer);
        var announcers = extractChildOfType(content, Announcers);
        var toasts = extractChildOfType(content, Toasts);
        return (React.createElement("div", { className: Layout_module_scss_1["default"].root },
            navbar,
            announcers,
            React.createElement("div", { className: Layout_module_scss_1["default"].page },
                header,
                toasts,
                React.createElement("div", { className: Layout_module_scss_1["default"].body },
                    React.createElement("div", { className: Layout_module_scss_1["default"].bodyInner },
                        sidebar,
                        React.createElement("main", { className: Layout_module_scss_1["default"].content }, content))),
                footer)));
    };
    Layout.displayName = "Layout";
    Layout.NavigationBar = NavigationBar;
    Layout.Sidebar = Sidebar;
    Layout.Header = Header;
    Layout.Footer = Footer;
    Layout.Toasts = Toasts;
    Layout.Announcers = Announcers;
    return Layout;
}(React.Component));
var extractChildOfType = function (children, type) {
    var match = children.find(function (child) {
        if (React.isValidElement(child) && typeof child.type === "function") {
            return child.type.displayName === type.displayName;
        }
        return false;
    });
    if (match) {
        var index = children.indexOf(match);
        children.splice(index, 1);
    }
    return match;
};
exports["default"] = Layout;
//# sourceMappingURL=Layout.js.map